import { sum } from "lodash";
import { startOfDay } from "date-fns";

/** Deterministically provides a game level for the user based on the date (so the user gets the same level all throughout the day) */
export function deterministicallyChooseLevel(numLevels: number): number {
  const dateStr = startOfDay(new Date()).toString();
  const nums = dateStr.split("").map((c) => c.charCodeAt(0));
  return (sum(nums) % numLevels) + 1;
}
